import axiosInstance from 'src/common/axiosInstance';

const phoneNumberService = {

    show(phoneNumberId) {

        return axiosInstance.get(
            `/phone-numbers/${phoneNumberId}`
        );

    },

    update(phoneNumberId, data) {

        return axiosInstance.put(
            `/phone-numbers/${phoneNumberId}`,
            data
        );

    },

    destroy(phoneNumberId) {

        return axiosInstance.delete(
            `/phone-numbers/${phoneNumberId}`
        );

    },

};

export default phoneNumberService;